// Billing B2.1: a phone number is required to book.
// Browser copy of toE164 in functions/helper/booking-rules.js. The server
// checks again, so a difference here can only block, never let a bad number in.
// functions/test/phone-copy.test.js fails if the two copies differ.

// Phone numbers with no + get this country code. US is the only market today.
export const DEFAULT_COUNTRY_CODE = '1';

/**
 * A phone number in E.164 form ('+18015550123'), or null if we cannot call it.
 * Keeps digits and a leading +. 10 digits, or 11 starting with 1 → US.
 * + and 8 to 15 digits → kept as is. Anything else (letters, an extension) → null.
 */
export function toE164(value) {
  if (typeof value !== 'string' && typeof value !== 'number') return null;
  const text = String(value).trim();
  // Only the characters people type in phone numbers. 'x12' or 'ext' → null.
  if (!text || !/^\+?[\d\s().\-]+$/.test(text)) return null;
  const digits = text.replace(/\D/g, '');
  if (text.startsWith('+')) {
    return digits.length >= 8 && digits.length <= 15 && digits[0] !== '0' ? `+${digits}` : null;
  }
  if (digits.length === 10 && !/^[01]/.test(digits)) return `+${DEFAULT_COUNTRY_CODE}${digits}`;
  if (digits.length === 11 && digits[0] === '1' && !/^[01]/.test(digits.slice(1))) return `+${digits}`;
  return null;
}
